import { store } from '@/app/app-store';
import { CampaignModel, IntegrationFileModel } from '@/app/shared/models';
import { refsService as refs } from '@/app/shared/refs.service';

import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({ store, name: 'campaignModule', namespaced: true, dynamic: true })
export class CampaignModule extends VuexModule {
  public campaignId = '';
  public campaigns: CampaignModel[] = [];

  @Mutation
  public SET_CAMPAIGN_ID(campaignId: string) {
    this.campaignId = campaignId;
  }
  @Mutation
  public SET_CAMPAIGNS(campaigns: []) {
    this.campaigns = campaigns;
  }

  @Action({ commit: 'SET_CAMPAIGN_ID', rawError: true })
  public async setCampaignId(campaignId: string) {
    return campaignId;
  }

  @Action({ rawError: true })
  public async getTemplateFiles(): Promise<IntegrationFileModel[]> {
    return await refs.services.campaign.GetTemplateFiles();
  }

  @Action({ commit: 'SET_CAMPAIGNS', rawError: true })
  public async getCampaignByContractId(
    contractId: string
  ): Promise<CampaignModel[] | undefined> {
    const settingCampaign = await refs.services.campaign.GetSettingCampaingByTenant(
      refs.modules.company.account.Id
    );
    if (settingCampaign && settingCampaign.length > 0) {
      const campaignPromise = refs.services.campaign.GetCampaignByContractId(
        contractId,
        100
      );
      const followUpPromise = refs.services.campaign.GetFollowUpByContractId(
        contractId,
        100
      );
      const [campaign, followUp] = await Promise.all([
        campaignPromise,
        followUpPromise,
      ]);

      let res = campaign;
      if (campaign && followUp) {
        res = campaign.concat(followUp);
      } else if (campaign) {
        res = campaign;
      } else if (followUp) {
        res = followUp;
      }

      const campaigns: CampaignModel[] | undefined = res?.map((campaign) => {
        const notifyId = followUp?.find(
          (followUpItem) => followUpItem.Id === campaign.Id
        )?.Id;

        campaign.SettingCampaign.CampaignId =
          campaign.SettingCampaignRuler.NotifyCampaignId;
        campaign.SettingCampaign.CommunicationId =
          campaign.SettingCampaignRuler.NotifyCommunicationId;

        campaign.SettingCampaign.InstallmentCampaigns = campaign
          .InstallmentCampaigns?.length
          ? campaign.InstallmentCampaigns
          : campaign.SettingCampaign.InstallmentCampaigns;

        campaign.SettingCampaign.NotifyId = notifyId || '';

        return campaign.SettingCampaign;
      });

      return campaigns;
    } else return [];
  }
}
